import React from "react";
import PropTypes from "prop-types";
import { CSCContext } from "../CSCContext";

class MarketoForm extends React.Component {
  static contextType = CSCContext;

  constructor() {
    super();

    this.waitMessageRef = React.createRef();
  }

  componentDidMount = () => {
    let {baseUrl, munchkinId, formId} = this.props;

    // The next comment may be required directly
    // above each MktoForms2 reference to compile:
    // eslint-disable-next-line no-undef
    MktoForms2.onFormRender(() => {
      if (this.waitMessageRef.current)
        this.waitMessageRef.current.style.display = "none";
    });

    // The next comment may be required directly
    // above each MktoForms2 reference to compile:
    // eslint-disable-next-line no-undef
    MktoForms2.loadForm(baseUrl, munchkinId, formId, (form) => {
      let userData = this.context.getUserData();
      userData.CSC_Submission_Date__c = ( new Date() ).toLocaleString('en-US', { 
        month: 'long', 
        day: 'numeric', 
        year: 'numeric', 
        timeZone: 'UTC' 
      });

      console.log(`Preparing form with hidden data fields: \n${JSON.stringify(userData, null, " \n")}`);
      form.addHiddenFields(userData);
      // A function that will be called when the form has been successfully submitted. This callback will be passed two arguments.  
      // A JS Object containing the values that were submitted and a String url of the follow up page that the user will be forwarded to, or null or empty string if there is no configured follow up page.
      form.onSuccess((values, url) => {
        console.log(`Sending form data to Marketo: \n${JSON.stringify(form.getValues(), null, "\n ")}`);
        this.context.nextPage();
        return false;
      });
    });
  }
  
  render() {
    return ( 
      <div className="marketo-form">
        <p ref={this.waitMessageRef} className="form-waiting-message">Form loading...</p>
        <form id="mktoForm_2491"></form>
      </div>
    );
  }
}

MarketoForm.propTypes = {
  buttonLabel: PropTypes.string.isRequired,
  baseUrl: PropTypes.string.isRequired,
  munchkinId: PropTypes.string.isRequired,
  formId: PropTypes.string.isRequired,
};

MarketoForm.defaultProps = {
  buttonLabel: "Send My Results",
  baseUrl: "//app-abc.marketo.com",
  munchkinId: "167-BOY-362",
  formId: "2491",
}

export default MarketoForm;
